<template>
  <div class="wrapper">
    <div class="effective">
      <!-- 左半部分 -->
      <div class="left-effective">
        <div class="">
          <div class="title-effective">
            许可证编号：
          </div>
          <div class="context">
            {{WarnInfoData.BusLicenceCode}}
          </div>
        </div>
        <div class="border-context">
          <div class="title-effective" style="min-width: 83px;">
            经营方式：
          </div>
          <div class="context">
            {{WarnInfoData.BusBusinessMode}}
          </div>
        </div>
           <div class="border-context">
          <div class="title-effective" style="min-width: 83px;">
            起始日期：
          </div>
          <div class="context">
            {{WarnInfoData.BusStartDate}}
          </div>
        </div>
        <div class="border-context">
          <div class="title-effective">
            医疗器械经营许可证
          </div>
          <div class="" style="  position: relative;left: -20px;top: -40px;">
            <CommonuploadEnclosure ref="UploadEnclisureRef" :typeUpload="3" title="" @getFile="UploadBL" :BLPhotoURL="WarnInfoData.BusPhotoURL" ></CommonuploadEnclosure>
          </div>
        </div>
      
      </div>
      <!--右半部分-->
      <div class="right-effective">
        <div class="">
          <div class="title-effective">
            企业名称：
          </div>
          <div class="context">
            {{WarnInfoData.BusCompanyName}}
          </div>
        </div>
        <div class="border-context" >
          <div class="title-effective">
            发证日期：
          </div>
          <div class="context">
             {{WarnInfoData.BusBusinessAddr}}
          </div>
        </div>
          <div class="border-context" >
          <div class="title-effective" >
            失效日期：
          </div>
          <div class="context">
           {{WarnInfoData.BusEndDate}}
          </div>
        </div>
      </div>
    </div>
    <div class="reject-Overdue">
      <img src="@/assets/channel/reject.png" alt="" style="width: 24px;height:24px;vertical-align: middle;margin-right: 10px;">
       <span v-html="$options.filters.filters2(WarnInfoList.StringMessage)">
      </span>
    </div>
  </div>
</template>

<script>
import CommonuploadEnclosure from '../../../../../../../components/common-upload-Enclosure.vue'
export default {
  components: { CommonuploadEnclosure },
  props: {
    WarnInfoData: {
      type: undefined
    },
     WarnInfoList: {
      type: Object
    }
  },
  filters: {
    filters2(arg) {
      let args = null
      if (arg) {
        args = arg.replace('<span style=\"\"color: #E71D43\"\">', '<span style="color: #E71D43">')
      }
      return args;
    }
  },
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
@import url(../../style/index.less);
</style>